import {
  carousel_image_url,
  gallery_image,
  image_thumbnail,
  image_url,
} from '@components/blocks/images/logic';

// flight-and-stay: le immagini stanno nelle statiche di prodotto, indicizzate per pid.
export const product_gallery_images = (
  product_detail = [],
  statics_detail = {}
) =>
  product_detail.reduce((images, product) => {
    const { pid } = product.baseProdotto || {};
    const { schedaProdotto = {} } = statics_detail[pid] || {};
    const { immagini = [] } = schedaProdotto;

    return {
      ...images,
      // sotto 800x600 lo scatto, stirato a tutta larghezza, è inutilizzabile
      [pid]: immagini
        .filter((image) => image.width >= 800 && image.height >= 600)
        .map((image) => gallery_image(image.src)),
    };
  }, {});

// only-stay: la struttura espone già la lista, con fallback sulla sola thumbnail.
export const hotel_gallery_images = (hotel = {}) => {
  const { images, thumbnail_url } = hotel;
  const source = images || (thumbnail_url ? [thumbnail_url] : []);

  return source.map((image) => gallery_image(image_url(image)));
};

export const room_carousel_images = (room = {}) => {
  const { images = [] } = room;

  return images
    .filter((image) => image_url(image))
    .map((image) => ({
      url: carousel_image_url(image_url(image)),
      thumbnail: image_thumbnail(image),
    }));
};

/**
 * Immagini della struttura nella forma attesa da <carousel> ({url, thumbnail}),
 * diversa dalla {url, large} del lightbox prodotta da gallery_image.
 *
 * flight-and-stay: le statiche di prodotto espongono src / srcthumb per scatto.
 *
 * @param {string} pid
 * @param {Object} statics_detail
 * @returns {Array<{url: string, thumbnail: string}>}
 */
export const product_carousel_images = (pid, statics_detail = {}) => {
  const { schedaProdotto = {} } = statics_detail[pid] || {};
  const { immagini = [] } = schedaProdotto;

  return immagini
    .filter((image) => image.width >= 800 && image.height >= 600)
    .map((image) => ({
      url: carousel_image_url(image.src),
      thumbnail: image.srcthumb || image.src,
    }));
};

/**
 * only-stay: la struttura espone gia' la lista, con fallback sulla sola thumbnail.
 *
 * @param {Object} hotel
 * @returns {Array<{url: string, thumbnail: string}>}
 */
export const hotel_carousel_images = (hotel = {}) => {
  const { images, thumbnail_url } = hotel;
  const source = images || (thumbnail_url ? [thumbnail_url] : []);

  return source.map((image) => ({
    url: carousel_image_url(image_url(image)),
    thumbnail: image_thumbnail(image),
  }));
};
